import AccountPage from './AccountPage.json';
import About from './About.json';
import AboutModal from './AboutModal.json';
import Actions from './Actions.json';
import AiAccelerate from './AiAccelerate.json';
import ApiAsService from './ApiAsService.json';
import Buttons from './Buttons.json';
import CardItems from './CardItems.json';
import ClinicalCollaboration from './ClinicalCollaboration.json';
import CineDialog from './CineDialog.json';
import Common from './Common.json';
import Dashboard from './Dashboard.json';
import DatePicker from './DatePicker.json';
import DrawingCanvas from './DrawingCanvas.json';
import Docs from './Docs.json';
import ExamManagement from './ExamManagement.json';
import Findings from './Findings.json';
import ForgotPassword from './ForgotPassword.json';
import GeneralViewer from './GeneralViewer.json';
import Header from './Header.json';
import LatestExams from './LatestExams.json';
import LatestReports from './LatestReports.json';
import Login from './Login.json';
import MeasurementTable from './MeasurementTable.json';
import MedicalViewsGrid from './MedicalViewsGrid.json';
import Menu from './Menu.json';
import NewCase from './NewCase.json';
import NewCaseWizard from './NewCaseWizard.json';
import Organization from './Organization.json';
import Patient from './Patient.json';
import PatientManagement from './PatientManagement.json';
import PatientSelectionModal from './PatientSelectionModal.json';
import RecentPatients from './RecentPatients.json';
import RealtimeExam from './RealtimeExam.json';
import Report from './Report.json';
import SetUpAccount from './SetUpAccount.json';
import SidePanel from './SidePanel.json';
import StudyBrowser from './StudyBrowser.json';
import StudyList from './StudyList.json';
import Surveys from './Surveys.json';
import Terms from './Terms.json';
import Toast from './Toast.json';
import UserManagement from './UserManagement.json';
import UserPreferencesModal from './UserPreferencesModal.json';
import ViewDetails from './ViewDetails.json';
import Scheduling from './Scheduling.json';
import Notifications from './Notifications.json';
import ViewportDownloadForm from './ViewportDownloadForm.json';

export default { 
  'en-US': {
    AccountPage,
    About,
    AboutModal,
    Actions,
    AiAccelerate,
    ApiAsService,
    Buttons,
    CardItems,
    ClinicalCollaboration,
    CineDialog,
    Common,
    Dashboard,
    DatePicker,
    DrawingCanvas,
    Docs,
    ExamManagement,
    Findings,
    ForgotPassword,
    GeneralViewer,
    Header,
    LatestExams,
    LatestReports,
    Login,
    MeasurementTable,
    MedicalViewsGrid,
    Menu,
    NewCase,
    NewCaseWizard,
    Organization,
    Patient,
    PatientManagement,
    PatientSelectionModal,
    RecentPatients,
    RealtimeExam,
    Report,
    SetUpAccount,
    SidePanel,
    StudyBrowser,
    StudyList,
    Surveys,
    Terms,
    Toast,
    UserManagement,
    UserPreferencesModal,
    ViewDetails,
    Scheduling,
    Notifications,
    ViewportDownloadForm,
  },
};
